import { Scene, Mesh, Color3, HighlightLayer, ShaderMaterial, Animation,AnimationGroup,StandardMaterial,MeshBuilder } from '@babylonjs/core';
import { ModelLoader } from './../../loader/ModelLoader';
import { GlobalObject } from '@/Engine/utils/GlobalObject';

export class WarnPoint {
    private scene: Scene;
    private wp?: Mesh;
    //private HL?: HighlightLayer;
    private mat?: StandardMaterial;
    private speed: number = 0.1;
    private pool: any[] = [];
    constructor(scene: Scene) {
        this.scene = scene;
        this.init();
    }
    public async init() {
        let loader = ModelLoader.instance;
        this.wp = await loader.getModel(GlobalObject.getInstance().main.source.common.iconWarning) as Mesh; 
        this.wp.scaling.set(1, 1, 1);
        this.wp.setEnabled(false); // 隐藏

        this.mat = new StandardMaterial("wp_hitbox", this.scene);
        this.mat.diffuseColor = new Color3(0.5, 0.5, 0.5);
        this.mat.alpha = 0;
    }
    public getObject() {
        if (this.pool.length > 0) {
            return this.pool.pop();
        } else {
            let point = this.clone() as any; // return a mesh
            return  point;
        }
    }
    public recycleObject(point:any) {
        if(point.parent){
            point.setEnabled(false);
            point.parent = null;
        }
        this.pool.push(point);
    }
    private clone() {
        if (this.wp) {
            let mesh = (this.wp as Mesh).clone();
            //mesh.animations = BabylonTools.cloneAnimations(((this.wp as Mesh).animations) as any) as any;
            let rotateAnim;
            let targetMesh = mesh.getChildren()[0].getChildren()[0];  // TransformNode.name = ".pCylinder1.polySurface3" 
            mesh.animations.forEach((item: any) => {
                if (item.name.indexOf('rotate') > -1) {
                    rotateAnim = item;
                    item.targetedAnimations[0].target = targetMesh;
                }
            })
            mesh.setEnabled(true);
            // mesh.scaling.set(1, 1, 1);
            if (rotateAnim) {
                let rAnim = rotateAnim as AnimationGroup;
                rAnim.start(true, 1.0, rAnim.from, rAnim.to, false);
                //rAnim.play(true);
            }

            let facility_box = MeshBuilder.CreateBox("facility_box", { size: 2, width: 1, height: 1, depth: 1 }, this.scene);
            facility_box.setParent(mesh);
            facility_box.scaling.set(0.75, 0.75, 0.75);
            facility_box.position.y = 0.5;
            (facility_box as Mesh).material = this.mat as StandardMaterial;
            facility_box.isPickable = true;
            return mesh;

        } else {
            console.log('we dont have original mesh.')
        }
    }
}